import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import StandardMenu from './StandardMenu';
import StandardMenuBranched from '../StandardMenu.complete_theme';
export default withFeatureBranch({
    complete_theme: StandardMenuBranched
})(StandardMenu);
